import { FormSubmit } from 'libs/form/Form';
import { useTranslation } from 'libs/i18n';
import { Button, Stack, Typography } from 'libs/ui';

import {
  Form,
  getSchema,
  Submit,
  CreateAdminFormType,
} from '../../forms/createAdminForm';
import { useCreateAdmin } from '../../hooks/useCreateAdmin';

import { DialogStyled } from './CreateAdminDialogFeature.styles';
import { FormContent } from './FormContent';

interface Props {
  isOpen: boolean;
  onClose?: () => void;
}

const DialogContentFeature = ({ onClose }: { onClose?: () => void }) => {
  const { t } = useTranslation();
  const { createFormError, createLoading, onSubmitCreate } = useCreateAdmin();

  const handleSubmit: FormSubmit<CreateAdminFormType> = async (
    values,
    helpers
  ) => {
    if (await onSubmitCreate(values, helpers)) {
      onClose?.();
    }
  };

  return (
    <Form
      initialErrors={createFormError}
      validationSchema={getSchema(t)}
      onSubmit={handleSubmit}
    >
      <Stack spacing={32}>
        <Typography align="center" variant="headerBold">
          {t('admin.createAdminDialog.title')}
        </Typography>
        <FormContent />
        <Stack alignItems="stretch" spacing={8}>
          <Submit
            fullWidth
            label={t('common.create')}
            loading={createLoading}
          />
          <Button
            fullWidth
            label={t('common.back')}
            mode="text"
            onClick={onClose}
          />
        </Stack>
      </Stack>
    </Form>
  );
};

export const CreateAdminDialogFeature = ({ isOpen, onClose }: Props) => (
  <DialogStyled disableBackdropClick isOpen={isOpen} onClose={onClose}>
    <DialogContentFeature onClose={onClose} />
  </DialogStyled>
);
